import React, { useContext } from 'react';
import Flag, { FlagGroup } from '@atlaskit/flag';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import { token } from '@atlaskit/tokens';

import { useFlagController, RootStateContext } from '@/controllers';
import { colors } from '@/styles';

const genericCopy =
  'Sorry about that.\
  Try checking your internet connection or reach out to #help-tome on slack.';

const FlagManager: React.FC = () => {
  const { messages } = useContext(RootStateContext);
  const errorState = useFlagController(messages.error);
  const successState = useFlagController(messages.status);

  function renderFlags() {
    const flags = [];

    if (errorState.isShowing) {
      flags.push(
        <Flag
          appearance="warning"
          icon={
            <ErrorIcon label="Warning" secondaryColor={token('color.icon.warning', colors.Y400)} />
          }
          id="warning"
          key="warning"
          title={messages.error.title || 'Network Error'}
          description={messages.error.message || genericCopy}
          actions={[{ content: 'Dismiss', onClick: () => errorState.setIsShowing(false) }]}
        />
      );
    }

    if (successState.isShowing) {
      flags.push(
        <Flag
          appearance="success"
          icon={
            <SuccessIcon
              label="Success"
              secondaryColor={token('color.icon.success', colors.G400)}
            />
          }
          id="success"
          key="success"
          title={messages.status.title || 'All good!'}
          description={messages.status.message}
          actions={[{ content: 'Dismiss', onClick: () => successState.setIsShowing(false) }]}
        />
      );
    }

    return flags;
  }

  return <FlagGroup>{renderFlags()}</FlagGroup>;
};

export default FlagManager;
